import theme from "lib/theme/theme";
import { SxObjType } from "lib/theme/types/SxObjType.type";

const sxStyles = (error: boolean | undefined) => {
  return {
    region: {
      pt: 1,
    },
    textFieldLabel: {
      color: theme.palette.primary.main,
      typography: theme.typography.body1_regular,
    },

    disabled: {
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderWidth: 0,
      },
      "& .MuiFormLabel-root.Mui-disabled": {
        color: theme.palette.primary.main,
      },
      mt: -0.2,
    },
    errText: {
      color: theme.palette.error.main,
      typography: theme.typography.caption1_regular,
      p: theme.spacing(0.5, 1.5),
    },
  } satisfies SxObjType;
};

export { sxStyles };
